import en from "./en";
import nl from "./nl";

const locales = {
  en: en,
  nl: nl,
};

export default locales;
